import React from 'react'
import * as styles from './artist-grid.module.css'

const ArtistGrid = ({ children }) => {
  return (
    <ul className={styles.grid}>
      {children}
    </ul>
  )
}

export default ArtistGrid
